import React, { Component } from 'react';
import axios from 'axios';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import UnAuthorised from './UnAuthorised';
import { Alert, DateRangePicker } from 'rsuite';
import 'react-select2-wrapper/css/select2.css';
import {
  URL_AADHAAREXTRACTION,
  createAndDownloadPdfForRcPrime,
  API_DOC_BASE_URL,
  rc_prime_pdf_Authorization_Token,
  rc_prime_pdf_user_id,
  rc_prime_pdf_rto_user_id,
  unlink_file,
  LOGIN_TYPE_ADMIN,
  LOGIN_TYPE_USER,
  CLIENT_EDIT_VIEW,
  SERVICE25_TEXT,
  SERVICE30_TEXT
} from './helper/Constants';

import Apihelpers from './helper/ApiHelper';
import FileDownload from 'js-file-download';
import { reactLocalStorage } from 'reactjs-localstorage';
import Header from './include/Header';

class aadhaarExtractionPdf extends Component {
  state = {
    Pan_Number: '',
    aadharFrontImg:'',
    aadharBackImg:'',
    aadhaar_extraction_details: [],
    MsgBoxText: '',
    is_data_found: false,
    data_not_found: '',
    bbuser_have_plan: false,
    rc_prime_pdf_user_id: '',
    rc_prime_pdf_Authorization_Token: '',
    rc_prime_pdf_rto_user_id: '',
    urlForBackButton: '',
  };
  constructor(props) {
    super(props);
  }
  async componentDidMount() {
    if (reactLocalStorage.get('login_type') === LOGIN_TYPE_USER) {
      this.setState({
        urlForBackButton: `${'/admin/client-edit-view/' +
          reactLocalStorage.get('login_user_id')}`,
      });
      this.Find_User_Have_Pan_Fetch_Pdf_Plan();
    }
    //when admin login then for get price prime data using testing Qa data
    if (reactLocalStorage.get('login_type') === LOGIN_TYPE_ADMIN) {
      const adminToken = 'Bearer '+ reactLocalStorage.get("internalToken");
      this.setState({
        rc_prime_pdf_user_id: rc_prime_pdf_user_id,
        rc_prime_pdf_Authorization_Token: adminToken,//rc_prime_pdf_Authorization_Token,
        rc_prime_pdf_rto_user_id: rc_prime_pdf_rto_user_id,
        urlForBackButton: '/admin/client-list',
      });
    }
  }
  get_aadhaar_extraction_details = async e => {
    e.preventDefault();
    $('.loader').css('display', 'block');
    console.log('this.state.aadharFrontImg',this.state.aadharFrontImg);
    if (this.state.aadharFrontImg !== '' && this.state.aadharFrontImg !== undefined) {
      let maxAllowedSize = 2 * 1024 * 1024;
      if (this.state.aadharFrontImg.size > maxAllowedSize || this.state.aadharBackImg.size > maxAllowedSize) {
        Alert.error('Please upload file less than 2MB');
        $('.loader').css('display', 'none');
      }
       const headerData = {
        authorization_Token: this.state.rc_prime_pdf_Authorization_Token,
        };

      var formData = new FormData();
      formData.append('user_id',this.state.rc_prime_pdf_user_id);
      formData.append('aadharFront',this.state.aadharFrontImg);
      formData.append('aadharBack',this.state.aadharBackImg);
      formData.append('authorization_Token',this.state.rc_prime_pdf_Authorization_Token);
      await Apihelpers.get_adhaarExtaction_details_apihelper(
        API_DOC_BASE_URL + URL_AADHAAREXTRACTION,
        formData,
        headerData
      ).then(res => {
        console.log('res.data--',res.data);
        if (res.data.statusCode == 200) {
          let result = res.data.data;
          console.log("result-------",result)
          $('.loader').css('display', 'none');
          this.setState({
            aadhaar_extraction_details: res.data.data,
            is_data_found: true,
          });
        } else if (res.data.statusCode == 204) {
          $('.loader').css('display', 'none');
          this.setState({
            is_data_found: false,
            data_not_found: 'Data Not Found',
          });
        } else {
          $('.loader').css('display', 'none');
          this.setState({
            is_data_found: false,
            data_not_found: 'Data Not Found',
          });
        }
      })
      .catch(err => {
        console.log("catch error=====>",err);
        $('.loader').css('display', 'none');
          this.setState({
            is_data_found: false,
            data_not_found: 'Data Not Found',
          });
      });


      //$('.loader').css('display', 'none');
    } else {
      Alert.error('Please upload aadhar');
      $('.loader').css('display', 'none');
    }
  };
  createAndDownloadPdf = () => {
    $('.loader').css('display', 'block');
    let currentDateTime = Date.now();
    if (
      this.state.aadhaar_extraction_details &&
      this.state.is_data_found == true
    ) {
      const data = {
        doc_details: [this.state.aadhaar_extraction_details],
        file_name:
          'aadhaar_extraction_details_' +
          this.state.Pan_Number +
          '_' +
          currentDateTime +
          '.pdf',
        type: 'aadhaarExtractionPdf',
      };
      Apihelpers.createAndDownloadPdf(
        createAndDownloadPdfForRcPrime,
        data,
      ).then(res => {
        console.log(res);
        if (res.status == 201) {
          var fileName = data.file_name;
          Apihelpers.downloadFileresponse(
            'export-rcprime-reportpdf/' + fileName,
          )
            .then(res => {
              FileDownload(res.data, fileName);
              const detlete_file_path = {
                filepath: 'rc_prime_pdf_report/' + fileName,
              };
              Apihelpers.postdataresponse(unlink_file, detlete_file_path);
            })
            .catch(err => {
              console.log(err);
            });
            $('.loader').css('display', 'none');
        } else {
          $('.loader').css('display', 'none');
          Alert.error('Error While Generating Report');
        }
      });
      //$('.loader').css('display', 'none');
    } else {
      $('.loader').css('display', 'none');
      Alert.error('Data Not Found');
    }
  };
  // On_pan_number_input_change(input) {
  //   this.setState({
  //     Pan_Number: input,
  //     is_data_found: false,
  //   });
  // }
  async Find_User_Have_Pan_Fetch_Pdf_Plan() {
    const bbuserid = reactLocalStorage.get('login_user_id');
    var startdate = '';
    var enddate = '';
    const ClientDetailsPostData = {
      startdate: '',
      enddate: '',
    };
    Apihelpers.postdataresponse(
      CLIENT_EDIT_VIEW + bbuserid,
      ClientDetailsPostData,
    ).then(async res => {
      if (res.data.status === true) {
        this.setState({
          rc_prime_pdf_Authorization_Token: 'Bearer '+ res.data.data[0].bbuserInfo[0].token,
        });
        /*var bbPaymentHistory = res.data.data[0].bbuserpaymenthistoriesInfo;
        let token = bbPaymentHistory.map(s => {
          if (s.is_active == true) {
            this.setState({
              rc_prime_pdf_Authorization_Token: 'Bearer ' + s.token,
            });
            return s.token;
          }
        });*/
        this.setState({
          rc_prime_pdf_user_id: bbuserid,
          rc_prime_pdf_rto_user_id: res.data.data[0].bbuserInfo[0].userid,
        });
        var parserActivePlan = JSON.parse(
          res.data.data[0].bbuserInfo[0].active_plan,
        );
        if (parserActivePlan.service.length > 0) {
          parserActivePlan.service.map((dataOfelement, index) => {
            if (
              dataOfelement.isActive == 1 &&
              dataOfelement.plantype === SERVICE25_TEXT
            ) {
              this.setState({ bbuser_have_plan: true });
            }
          });
        }
      }
    });
  }
  render() {
    if (reactLocalStorage.get('login_type') === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_api_aadhaarExtractionpdf_service") === SERVICE30_TEXT) {
      const is_data = this.state.is_data_found;
      return (
        <div className="wrapper">
          <Header />
          <div className="container">
            <div className="whiteBox challanPdfPage">
              <div className="titleRow">
                <div className="row">
                  <div className="col">
                    <h3 className="title">Aadhaar Extraction Details</h3>
                  </div>
                  <div className="col">
                    <NavLink
                      to={this.state.urlForBackButton}
                      exact
                      style={{
                        float: 'right',
                        fontSize: '13px',
                        color: '#1a73e8',
                        textDecoration: 'none',
                      }}
                    >
                      {' '}
                      <i className="fa fa-arrow-left" /> Back
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="mapFilterRow">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="control-title">Upload Front Aadhaar </label>
                      <input
                        className="form-control"
                        type="file"
                        id="aadharFrontImg"
                        onChange={(e)=>{
                          this.setState({aadharFrontImg:e.target.files[0]});
                        }}
                        accept="image/jpeg,mage/jpg,image/gif,image/png,application/pdf"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="control-title">Upload Back Aadhaar </label>
                      <input
                        className="form-control"
                        type="file"
                        id="aadharBackImg"
                        onChange={(e)=>{
                          this.setState({aadharBackImg:e.target.files[0]});
                        }}
                        accept="image/jpeg,mage/jpg,image/gif,image/png,application/pdf"
                      />
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="btnRow">
                      <button
                        className="yellowBtn"
                        type="button"
                        tabIndex="3"
                        onClick={this.get_aadhaar_extraction_details}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                 <div className="col-md-1">
                    <div className="btnRow">
                      <button
                        className="yellowBtn"
                        type="button"
                        style={{ backgroundColor: '#1a73e8' }}
                        tabIndex="4"
                        onClick={this.createAndDownloadPdf}
                      >
                        Download
                      </button>
                    </div>
                  </div> 
                </div>
                <div className="challanInfoBlock">
                  {is_data ? (
                      <>
                         <div className="challanBox">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Aadhaar Number : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.AadhaarNumber}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Name : </div>
                                <div className="val">{this.state.aadhaar_extraction_details.Name}</div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Date Of Birth : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.DateOfBirth}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Year Of Birth : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.YearOfBirth}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Pin Code : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.PinCode}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Gender : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.Gender}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Date Of Issue : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.DateOfIssue}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Expiry Date : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.ExpiryDate}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">ValidateBackAndFront : </div>
                                <div className="val">{this.state.aadhaar_extraction_details.ValidateBackAndFront?.toString()}</div>
                              </div>
                            </div>
                             <div className="col-md-12">
                              <div className="infoRow">
                                <div className="key">Full Address : </div>
                                <div className="val">
                                  {this.state.aadhaar_extraction_details.FullAddress}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                  ) : (
                    <>
                      <div className="infoRow">
                        <div
                          style={{
                            color: '#1a73e8',
                            display: 'inline',
                            fontSize: '30px',
                          }}
                        >
                          {this.state.data_not_found}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="loader" style={{ display: 'none' }}>
            <div className="bg" />
            <img
              className="loadingImg"
              src="/assets/images/loading.gif"
              alt=""
            />
          </div>
        </div>
      );
    } else {
      return <UnAuthorised />;
    }
  }
}
export default aadhaarExtractionPdf;
